import { useContext, useEffect, useState } from "react";
import Logo from "../../assets/images/sblogo.png";
import { MyContext } from "../../App";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import { postData } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Helmet } from "react-helmet-async";
const SignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formfields, setFormfields] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    isAdmin: false,
  });

  const context = useContext(MyContext);
  const history = useNavigate();

  useEffect(() => {
    context.setIsHeaderFooterShow(false);

    context.setEnableFilterTab(false);
  }, []);

  const onchangeInput = (e) => {
    setFormfields(() => ({
      ...formfields,
      [e.target.name]: e.target.value,
    }));
  };

  const register = (e) => {
    e.preventDefault();
    try {
      if (formfields.name === "") {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "name can not be blank!",
        });
        return false;
      }

      if (formfields.email === "") {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "email can not be blank!",
        });
        return false;
      }

      if (formfields.phone === "") {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "phone can not be blank!",
        });
        return false;
      }

      if (formfields.password === "") {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "password can not be blank!",
        });
        return false;
      }

      setIsLoading(true);

      postData("/api/user/signup", formfields)
        .then((res) => {
          if (res.success === true) {
            localStorage.setItem("userEmail", formfields.email);
            localStorage.setItem("token", res.token);

            const user = {
              name: res.user?.name,
              email: res.user?.email,
              userId: res.user?.id,
              image: res?.user?.images[0],
            };

            localStorage.setItem("user", JSON.stringify(user));
            context.setUser(JSON.stringify(user));

            context.setAlertBox({
              open: true,
              error: false,
              msg: res.msg,
            });

            setTimeout(() => {
              history("/");
              context.setIsLogin(true);
              setIsLoading(false);
              context.setIsHeaderFooterShow(true);
              //window.location.href = "/";
            }, 2000);
          } else {
            setIsLoading(false);
            context.setAlertBox({
              open: true,
              error: true,
              msg: res.msg,
            });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error posting data:", error);
          // Handle error (e.g., show an error message)
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="section signInPage min-h-screen bg-gray-50 flex items-center justify-center py-6">
      <Helmet>
        <title>Create Account - SabbaFarm</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Register to shop the best agricultural products in India."
        />
        <link rel="canonical" href="https://sabbafarm.com/signup" />
      </Helmet>

      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-6">
            <div className="text-center mb-6">
              <img
                src={Logo}
                className="w-32 h-32 mx-auto mb-3"
                alt="Sabba Farm Logo"
              />
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                Create Account
              </h2>
              <p className="text-gray-600 text-sm">
                Join SabbaFarm and start your journey
              </p>
            </div>

            <form onSubmit={register} className="space-y-4">
              <div className="space-y-3">
                <TextField
                  label="Full Name"
                  name="name"
                  onChange={onchangeInput}
                  type="text"
                  variant="outlined"
                  fullWidth
                  required
                  className="bg-white"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#16a34a",
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#16a34a",
                    },
                  }}
                />

                <TextField
                  label="Phone Number"
                  name="phone"
                  onChange={onchangeInput}
                  type="tel"
                  variant="outlined"
                  fullWidth
                  required
                  className="bg-white"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#16a34a",
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#16a34a",
                    },
                  }}
                />

                <TextField
                  label="Email Address"
                  name="email"
                  onChange={onchangeInput}
                  type="email"
                  variant="outlined"
                  fullWidth
                  required
                  className="bg-white"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#16a34a",
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#16a34a",
                    },
                  }}
                />

                <TextField
                  label="Password"
                  name="password"
                  onChange={onchangeInput}
                  type="password"
                  variant="outlined"
                  fullWidth
                  required
                  className="bg-white"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#16a34a",
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#16a34a",
                    },
                  }}
                />
              </div>

              <div className="flex flex-col space-y-3 pt-2">
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  className="bg-green-600 hover:bg-green-700 text-white py-2 rounded-md text-base font-medium"
                  disabled={isLoading}
                  sx={{
                    backgroundColor: "#16a34a",
                    "&:hover": {
                      backgroundColor: "#15803d",
                    },
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Create Account"
                  )}
                </Button>

                <Link to="/" className="text-center">
                  <Button
                    variant="outlined"
                    fullWidth
                    className="border-green-300 text-green-700 hover:bg-green-50 py-2 rounded-md text-base"
                    onClick={() => context.setIsHeaderFooterShow(true)}
                    sx={{
                      borderColor: "#86efac",
                      color: "#15803d",
                      "&:hover": {
                        borderColor: "#86efac",
                        backgroundColor: "#f0fdf4",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                </Link>
              </div>

              <p className="text-center text-gray-600 mt-4 text-sm">
                Already have an account?{" "}
                <Link
                  to="/signIn"
                  className="text-green-600 hover:text-green-700 font-medium"
                >
                  Sign In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
